import { render, staticRenderFns } from "./ds-error-state.vue?vue&type=template&id=2c83b90a&scoped=true"
import script from "./ds-error-state.vue?vue&type=script&lang=js"
export * from "./ds-error-state.vue?vue&type=script&lang=js"
import style0 from "./ds-error-state.vue?vue&type=style&index=0&id=2c83b90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83b90a",
  null
  
)

export default component.exports